import "../scss/main.scss";
Vue.component("item-availability-heista", () => import("./app/Item_Availability_Heista.vue"));



